"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NaniumStream = void 0;
const objects_1 = require("../objects");
const naniumBuffer_1 = require("./naniumBuffer");
let uuidCounter = 0;
class NaniumStream {
    get isBinary() {
        return naniumBuffer_1.NaniumBuffer.isNaniumBuffer(this[objects_1.responseTypeSymbol]);
    }
    constructor(itemConstructor, genericTypeInfo, id) {
        this.test1 = true;
        this[objects_1.responseTypeSymbol] = itemConstructor !== null && itemConstructor !== void 0 ? itemConstructor : naniumBuffer_1.NaniumBuffer;
        this[objects_1.genericTypesSymbol] = genericTypeInfo;
        this.id = id !== null && id !== void 0 ? id : Date.now() + '-' + Math.random().toFixed(20).substring(2) + '-' + (++uuidCounter);
        this[NaniumStream.naniumStreamOnDataHandlerSymbol] = [];
        this[NaniumStream.naniumStreamOnErrorHandlerSymbol] = [];
        this[NaniumStream.naniumStreamOnEndHandlerSymbol] = [];
    }
    //#region Promise
    toPromise() {
        return new Promise((resolve, reject) => {
            try {
                const objectList = [];
                const buffer = new naniumBuffer_1.NaniumBuffer();
                this.onData((chunk) => {
                    if (this.isBinary) {
                        buffer.write(chunk);
                    }
                    else {
                        objectList.push(chunk);
                    }
                });
                this.onEnd(() => {
                    resolve(this.isBinary ? buffer : objectList.flat(Infinity));
                });
                this.onError((err) => {
                    reject(err);
                });
            }
            catch (err) {
                reject(err);
            }
        });
    }
    //#region readable
    onData(handler) {
        this[NaniumStream.naniumStreamOnDataHandlerSymbol].push(handler);
        return this;
    }
    onError(handler) {
        this[NaniumStream.naniumStreamOnErrorHandlerSymbol].push(handler);
        return this;
    }
    onEnd(handler) {
        this[NaniumStream.naniumStreamOnEndHandlerSymbol].push(handler);
        return this;
    }
    pipeTo(s) {
        this.onData(chunk => s.write(chunk));
        this.onEnd(() => s.end());
        this.onError((err) => s.error(err));
    }
    // pipeThrough()
    //#endregion readable
    //#region writable
    write(chunk) {
        // if (NaniumBuffer.isNaniumBuffer(chunk)) {
        // 	this.buffer.write(chunk);
        // } else {
        if (Array.isArray(chunk)) {
            chunk.forEach(item => this[NaniumStream.naniumStreamOnDataHandlerSymbol].forEach(fn => fn(item)));
        }
        else {
            this[NaniumStream.naniumStreamOnDataHandlerSymbol].forEach(fn => fn(chunk));
        }
        // }
    }
    error(error) {
        this[NaniumStream.naniumStreamOnErrorHandlerSymbol].forEach(fn => fn(error));
    }
    end() {
        this[NaniumStream.naniumStreamOnEndHandlerSymbol].forEach(fn => fn());
    }
    //#end region writable
    //#endregion Stream
    static forEachStream(obj, fn) {
        if (NaniumStream.isNaniumStream(obj === null || obj === void 0 ? void 0 : obj.constructor)) {
            fn(obj, undefined); // todo: item type with generic parameter
        }
        objects_1.NaniumObject.forEachProperty(obj, (name, parent, typeInfo) => {
            if (NaniumStream.isNaniumStream(typeInfo === null || typeInfo === void 0 ? void 0 : typeInfo.ctor)) {
                const stream = parent[name[name.length - 1]];
                if (stream) {
                    fn(stream, typeInfo.localGenerics['T']);
                }
            }
        });
    }
    static isNaniumStream(objectOrConstructor) {
        var _a;
        return (objectOrConstructor === null || objectOrConstructor === void 0 ? void 0 : objectOrConstructor['naniumStreamOnEndHandlerSymbol']) != undefined ||
            ((_a = objectOrConstructor === null || objectOrConstructor === void 0 ? void 0 : objectOrConstructor.constructor) === null || _a === void 0 ? void 0 : _a['naniumStreamOnEndHandlerSymbol']) != undefined;
    }
}
NaniumStream.naniumStreamOnDataHandlerSymbol = Symbol.for('NaniumStream_OnDataHandlerSymbol');
NaniumStream.naniumStreamOnErrorHandlerSymbol = Symbol.for('NaniumStream_OnErrorHandlerSymbol');
NaniumStream.naniumStreamOnEndHandlerSymbol = Symbol.for('NaniumStream_OnEndHandlerSymbol');
__decorate([
    (0, objects_1.Type)(String),
    __metadata("design:type", String)
], NaniumStream.prototype, "id", void 0);
exports.NaniumStream = NaniumStream;
//# sourceMappingURL=naniumStream.js.map